import HttpClient from '../HttpService';

function list(page, limit, filter = {}) {
	return HttpClient.post(`/dispatches/list?page=${page}&limit=${limit}`, filter);
}

function createBulk(dispatches) {
	return HttpClient.post('/dispatches/bulk', { dispatches });
}

function destroy(uuid) {
	return HttpClient.delete(`/dispatches/${uuid}`);
}

function getByUUID(uuid) {
    return HttpClient.get(`/dispatches/${uuid}`);
}

function getPublicByUUID(uuid) {
    return HttpClient.get(`/dispatches/public/${uuid}`);
}

function update(uuid, data) {
	return HttpClient.put(`/dispatches/${uuid}`, data);
}

function submit(uuid, data) {
    return HttpClient.post(`/dispatches/${uuid}/submit`, data);
}

function listSendGroups(company, competence_date) {
	return HttpClient.post('/dispatches/groups', {
		company,
		competence_date
	});
}

export default {
	listSendGroups,
	submit,
	list,
	getPublicByUUID,
	createBulk,
	destroy,
    getByUUID,
	update
};
